// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './main.vue'
// import axios from 'axios'
import store from '../utils/store'
import router from '../router'
import clipboard from 'clipboard';
//import getGlobal from  '../utils/global.data';//设置全局使用的活动值
import qs from 'qs'
import Vant from 'vant';
import 'vant/lib/index.css';

import '../../static/css/base.css'
import '../../static/css/style.scss'
import '../../static/css/adapter.scss'

Vue.config.productionTip = false
Vue.use(Vant);

Vue.config.ignoredElements = [
	'wx-open-launch-weapp',
]

jm = new JM({
	errorUrl: '', //跳转错误页面
  jumpError:false,
  show_auth_tips:false,//是否显示授权弹框
  show_version:false,//是否显示左下角的时间戳版本号,如果不想用时间戳,也可以调用jm.showVer(msg)方法自己设置显示版本号
	is_gps_force: false, // 强制定位
});
//注册到vue原型上
Vue.prototype.clipboard = clipboard;
//Vue.prototype.global_data=getGlobal();

/*axios*/
/*二次封装axios*/
//错误执行方法
function errorState(res) {
	// 如果http状态码正常，则直接返npm回数据
	if(res && res.status && (res.status == 200 || res.status == 304 || res.status == 400)) {
		return res.data
	} else if(res && res.status && res.data && res.status == 500) {
		//jm.showMsg(res.data.msg); 直接跳错误页面
	} else if(res.status == 311 || res.status == 312) {
		if(res.status == 311) {
			jm.goAuth(2)
		} else {
			jm.goAuth(1)
		}
	} else {
		jm.showMsg(res.statusText);
	}
}
//成功执行的方法
function successState(res) {
	if(res.code == 311) {
		jm.goAuth(2);
		return;
	}
	if(res.code == 311) {
		jm.goAuth(1);
		return false;
	}
  if(res.msg && res.msg == '请登录'){
    jm.goAuth(2);
    return false;
  }
	if(res.code && res.code != 312 && res.code != 311 && !res.success && res.msg&&store.state.showErrorMsg) {
		jm.showMsg(res.msg);
	}
}
//格式化请求数据
function formatConfig(config) {
	if(config.method == "get") { //get请求
		if(config.params) {
			for(let key in config.params) {
				if(config.params[key] == "") {
					delete config.params[key]
				}
			}
		}
	} else if(config.method == "put" || config.method == "delete" || config.method == "post") { //put请求和delete请求post请求
		if(config.data && config.headers['Content-Type'] == "application/x-www-form-urlencoded;charset=UTF-8") {
			config.data = getParamsData(config.data);
		} else {
			for(let key in config.data) {
				if(config.data[key] === "" || config.data[key] === null) {
					delete config.data[key]
				}
			}
		}
	}
	return config;
}
//删除value是空的项
function getParamsData(_data) {
	let index = -1,
		arr = [],
		length = 0,
		res = {};
	if(_data) {
		arr = _data.split('&');
		length = arr.length;
		for(let i = 0; i < length; i++) {
			res[arr[i].split('=')[0]] = arr[i].split('=')[1];
		}
		let _str = "";
		for(let key in res) {
			if(res[key] !== "") {
				if(!_str) {
					_str = key + "=" + res[key];
				} else {
					_str = _str + "&" + key + "=" + res[key];
				}
			}
		}
		res = _str;
	} else {
		res = {};
	}
	return res;
}
function  getReshightAndWidth() {
    //设计尺寸 w:750 h:1108
    //1.计算屏幕实际尺寸width / 设计图宽度比 750  宽度比;
    //2.通过比例算出高度应该是多少时，是完美比例
    //3.计算出实际高度与完美高度 的比例
    let adpter_scale = 1;
    let screen_width = document.body.clientWidth; //屏幕实际宽度
    let screen_height = document.body.clientHeight; //屏幕实际高度
    let w_scale = screen_width / 750; //计算屏幕实际尺寸width / 设计图宽度比 750  宽度比;
    let compute_height = 1108 * w_scale; //通过比例算出高度应该是多少时，是完美比例
    adpter_scale =parseInt((screen_height / compute_height)*100)/100; //计算出实际高度与完美高度 的比例
    store.commit("updataAdpterScale", adpter_scale);
}
getReshightAndWidth()

let errConfig = ''
//添加请求拦截器
axios.interceptors.request.use(config => { //在发送请求之前执行方法
	if(config.headers && !config.headers.noLoading) {
		store.commit('updataLoading', true) //显示loading
	}

	errConfig = config

	if(config.headers && !config.headers.noErrorMsg) {
		store.commit('updataShowErrorMsg', true) //是否显示错误信息
	}
	delete config.headers.noLoading
	delete config.headers.noErrorMsg
	// console.log(config);
	if(config.method == "get") { //设置content-type;
		config.headers['Content-Type'] = "application/json; charset=utf-8";
	}

	config.headers['apitoken'] = jm.getApiToken()

	config = formatConfig(config);
	return config
}, error => { //请求错误时执行方法
	//console.log("500")
	return Promise.reject(error)
})
//添加响应拦截器
axios.interceptors.response.use(response => { //响应数据执行方法
	store.commit('updataLoading', false);
	successState(response.data);
	store.commit('updataShowErrorMsg', false);
	return response.data
}, error => {
	errorState(error.response)
	//return Promise.resolve(error.response)  //请求错误执行方法
})
//设置默认请求头
axios.defaults.headers = {
	// 'Content-Type': 'application/x-www-form-urlencoded'
	share: jm.is_from_share,
	code: jm.getCode(),
	actcode: jm.getActCode(),
	apitoken: jm.getApiToken(),
	unique_identity: localStorage.getItem("unique_identity"),
}

console.log(axios.defaults.headers, 111111)
axios.defaults.baseURL = jm.site.WEBSITE + "/api/v1";
Vue.prototype.$axios = axios; //引用axios
Vue.prototype.$qs = qs; //qs模块，post data
/* eslint-disable no-new */
Vue.prototype.$pointData = function(log_content) {
	let page_name = this.$route.meta.title;
	this.$axios.post("/act/data/extra/log", this.$qs.stringify({
		province_name: jm.gps.provice_name ? jm.gps.provice_name : "",
		city_name: jm.gps.city_name ? jm.gps.city_name : "",
		area_name: jm.gps.area_name ? jm.gps.area_name : "",
		address_detail: jm.gps.address ? jm.gps.address : "",
		longitude:jm.gps.longitude?jm.gps.longitude:"",
		latitude:jm.gps.dimension?jm.gps.dimension:"",
		phone_model:jm.gps.phone_name?jm.gps.phone_name:"",
		page_name: page_name ? page_name : "",
		log_content: log_content
	}), {
		headers: {
			"content-type": "application/x-www-form-urlencoded;charset=UTF-8",
			noLoading: true
		}
	}).then(res => {})
}
//自定义样式指令
let adpter_scale = store.state.adpter_scale;
console.log(adpter_scale)
Vue.directive('margin', { //margin 上,右,下,左
  bind: function (el, binding, vnode) {
    let value = binding.expression.split(',');
    if(+value[0])  el.style.marginTop = +value[0] * adpter_scale  + 'rem';
    if(+value[1])  el.style.marginRight = +value[1] * adpter_scale  + 'rem';
    if(+value[2])  el.style.marginBottom = +value[2] * adpter_scale  + 'rem';
    if(+value[3])  el.style.marginLeft = +value[3] * adpter_scale  + 'rem';
  }
})
Vue.directive('padding', { //padding 上,右,下,左
  bind: function (el, binding, vnode) {
    let value = binding.expression.split(',');
    if(+value[0])  el.style.paddingTop = +value[0] * adpter_scale  + 'rem';
    if(+value[1])  el.style.paddingRight = +value[1] * adpter_scale  + 'rem';
    if(+value[2])  el.style.paddingBottom = +value[2] * adpter_scale  + 'rem';
    if(+value[3])  el.style.paddingLeft = +value[3] * adpter_scale  + 'rem';
  }
})
Vue.directive('height', { //高度
  bind: function (el, binding, vnode) {
    let value = binding.value;
    if(+value)  el.style.height = +value * adpter_scale  + 'rem';
  }
})
Vue.directive('width', { //宽度
  bind: function (el, binding, vnode) {
    let value = binding.value;
    if(+value)  el.style.width = +value * adpter_scale  + 'rem';
  }
})
Vue.directive('line-height', { //行高
  bind: function (el, binding, vnode) {
    let value = binding.value;
    if(+value)  el.style.lineHeight = +value * adpter_scale  + 'rem';
  }
})

new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/view/main.js